import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {AlgemeneTipsComponent} from './algemene-tips/algemene-tips.component';
import { TipsHeaderComponent } from './tips-header/tips-header.component';

@NgModule({
  declarations: [
    AlgemeneTipsComponent,
    TipsHeaderComponent
  ],
  imports: [
    CoreModule,
  ],
  exports: [
    AlgemeneTipsComponent,
    TipsHeaderComponent
  ],
})
export class AlgemeneTipModule {}
